import { gql } from '@apollo/client';
import type { MotStatusTypes } from '$declarations/mostStatus';

export const VEHICLE_ERROR_PAGE = '/checkout/error/vehicle';
export const GENERIC_ERROR_PAGE = '/error';

/**
 * Make sure to lowercase the reason unsupported before checking against this type.
 * Database contains the same reasons with different case.
 */
export enum VehicleReasonUnsupported {
  NO_DATA = 'no data',
  SORN = 'vehicle was sorn',
  MAXIMUM_WEIGHT_EXCEEDED = 'maximum weight exceeded',
  UNSUPPORTED_CATEGORY_TYPE = 'unsupported category type',
  UNSUPPORTED_ELECTRIC_VEHICLE = 'UNSUPPORTED_ELECTRIC_VEHICLE',
  UNSUPPORTED_PLUG_IN_HYBRID_VEHICLE = 'UNSUPPORTED_PLUG_IN_HYBRID_VEHICLE',
}

export enum VehicleFuelType {
  ELECTRICITY = 'ELECTRICITY',
  DIESEL = 'DIESEL',
  HYBRID = 'HYBRID',
  PLUG_IN_HYBRID = 'PLUG_IN_HYBRID',
  PETROL = 'PETROL',
}

export interface IVehicle {
  readonly vehicleId: string;
  readonly vrm: string;
  readonly make: string;
  readonly model: string;
  readonly fuelType?: string;
  readonly litre?: string;
  readonly logo?: string;
  readonly motExpiryDate?: string;
  readonly nextMotDate?: string;
  readonly nextTaxDate?: string;
  readonly dateRegistered?: string;
  readonly vehicleAge?: number;
  readonly motCompletedDateTime?: string;
  readonly lastEstimatedMiles?: number;
  /**
   * VehicleReasonUnsupported but with case variations.
   */
  readonly reasonUnsupported?: string | null;
  readonly motStatus?: MotStatusTypes;
}

export interface QueryGetVehicle {
  readonly getVehicle: IVehicle;
}

export const FRAGMENT_VEHICLE = gql`
  fragment VehicleFields on Vehicle {
    vehicleId
    vrm
    make
    model
    fuelType
    litre
    logo
    motExpiryDate
    nextMotDate
    nextTaxDate
    dateRegistered
    vehicleAge
    motCompletedDateTime
    lastEstimatedMiles
    reasonUnsupported
  }
`;

export const QUERY_GET_VEHICLE = gql`
  query getVehicle($vehicleId: String!) {
    getVehicle(vehicleId: $vehicleId) {
      ...VehicleFields
    }
  }
  ${FRAGMENT_VEHICLE}
`;

export interface MutationCreateElectricVehicleLeadRequest {
  createLeadRequest: {
    email: string;
  };
}

export const MUTATION_CREATE_ELECTRIC_VEHICLE_LEAD_REQUEST = gql`
  mutation createElectricVehicleLeadRequest($leadInput: LeadInputGql!) {
    createLeadRequest(leadInput: $leadInput) {
      email
    }
  }
`;
